import React from 'react'

const PdfDocumentContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
            <div className={`${containerObject.attributes.class}`}>
                {containerObject.articles && containerObject.articles ? containerObject.articles.map((iframe) => {
                    return (
                        <>
                            <div>
                                <iframe className={`${iframe.attributes.class}`} src={iframe.attributes.linkUrl} width="" height="" frameborder="0.5">
                                </iframe>
                            </div>
                        </>
                    )
                }) : ''}
            </div>
        </div>
    )
}

export default PdfDocumentContainer
